import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import ReactDOM from "react-dom";
import { theme } from "styles/theme";
import App from "./app";
import { Provider } from "react-redux";
import store from "redux/store";

const container = document.getElementById("app");
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
);
